module.exports = __webpack_public_path__ + "static/media/open-engine-graph1.216d7bd0.svg";